// Banner Image Replacement Script - Rafael Implementation
// Updated: 2026-05-20
// Purpose: Replace carousel banner images with optimized Unsplash images (1280x650)

(function() {
  const imageMapping = {
    "banner1_hero_living_room": "https://images.unsplash.com/photo-1633505899118-4ca6bd143043?w=1280&h=650&fit=crop&q=85",
    "banner2_closeup_texture": "https://images.unsplash.com/photo-1600494448850-6013c64ba722?w=1280&h=650&fit=crop&q=85",
    "banner3_installation_diy": "https://images.unsplash.com/photo-1618221381711-42ca8ab6e908?w=1280&h=650&fit=crop&q=85",
    "banner4_home_office": "https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=1280&h=650&fit=crop&q=85",
    "Woman with tea in cozy room": "https://images.unsplash.com/photo-1666037805138-f227944ed8d7?w=1280&h=650&fit=crop&q=85"
  };

  function replaceCarouselImages() {
    Object.entries(imageMapping).forEach(([altText, newSrc]) => {
      const img = document.querySelector(`img[alt="${altText}"]`);
      if (img) {
        img.src = newSrc;
        img.srcset = "";
        img.loading = "eager";
        img.style.objectFit = "cover";
        img.style.objectPosition = "center";
      }
    });
  }

  // Replace on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceCarouselImages);
  } else {
    replaceCarouselImages();
  }

  // Also watch for dynamic carousel changes
  const observer = new MutationObserver(replaceCarouselImages);
  const carouselContainer = document.querySelector('[class*="ai-hero-carousel"]');
  if (carouselContainer) {
    observer.observe(carouselContainer, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
  }
})();